/**
 * 轻量服务端时钟(对齐 mobile src/utils/serverTime.ts 的最小子集):
 * 每个 API 响应的 Date 头校准 offset,serverNowMs() = Date.now() + offset。
 * 打卡计时/actionTime 用它,防客户端时钟漂移。无持久化(刷新后首个响应即校准)。
 *
 * ⚠️ 跨域前提:`Date` 不是 CORS safelist 响应头,后端必须配
 * `Access-Control-Expose-Headers: Date` 浏览器才允许 JS 读到,否则本时钟
 * 静默退化为客户端时钟(root cause 在后端 CORS 配置,非前端可修)。下面的
 * 一次性诊断 warn 用于在该配置缺失时大声暴露,方便拿日志找后端。
 */
let offsetMs = 0;
let syncedOnce = false;
let warnedDateHidden = false;

export function syncServerClockFromHeaders(
  headers: Record<string, unknown> | undefined,
): void {
  const raw = headers?.["date"];
  if (typeof raw !== "string") {
    if (!syncedOnce && !warnedDateHidden) {
      warnedDateHidden = true;
      console.warn(
        "[serverClock] Date 响应头不可读,服务端时钟校准未生效 — 跨域下需后端 " +
          "Access-Control-Expose-Headers: Date;headers keys:",
        headers ? Object.keys(headers) : headers,
      );
    }
    return;
  }
  const serverMs = Date.parse(raw);
  if (Number.isNaN(serverMs)) return;
  offsetMs = serverMs - Date.now();
  syncedOnce = true;
}

export function serverNowMs(): number {
  return Date.now() + offsetMs;
}

export function serverNowIso(): string {
  return new Date(serverNowMs()).toISOString();
}

export function _resetServerClockForTest(): void {
  offsetMs = 0;
  syncedOnce = false;
  warnedDateHidden = false;
}
